import { Component, Input, OnInit } from '@angular/core';
import * as echarts from 'echarts';
import { EChartsOption } from 'echarts';
import { ContactDto } from 'src/portal/contact-api/models/contact-dto';
@Component({
  selector: 'profile-skills',
  templateUrl: './profile-skills.component.html',
  styleUrls: ['./profile-skills.component.scss']
})
export class ProfileSkillsComponent implements OnInit {
  @Input() contact:ContactDto;

  chartOption: EChartsOption =  {
    title: {
      text: ''
    },
    legend: {
      data: ['Your Company Average','User Score', 'People In Job Percentage'],

      top: 0,
      left: 'left',
      orient: 'vertical',
    },
    radar: {
       shape: 'circle',
      indicator: [
        { name: 'DBMS Concepts', max: 6500 },
        { name: 'Algorithms', max: 16000 },
        { name: 'Problem Solving', max: 30000 },
        { name: 'Comunication Skills', max: 38000 },
        { name: 'Coding', max: 52000 },
        { name: 'MySql', max: 25000 }
      ]
    },
    series: [
      {
        name: 'Budget vs spending',
        type: 'radar',
        data: [
          {
            value: [5200, 6500, 23500, 28000, 45000, 19000],
            name: 'Your Company Average'
          },
          {
            value: [4200, 3000, 20000, 35000, 50000, 18000],
            name: 'User Score'
          },
          {
            value: [5000, 14000, 28000, 26000, 42000, 21000],
            name: 'People In Job Percentage',
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: 'rgba(250, 200, 88, 0.1)',
                  offset: 0
                },
                {
                  color: 'rgba(250, 200, 88, 0.7)',
                  offset: 1
                }
              ])
            }
          }
        ]
      }
    ]
  };

  constructor() { }

  showAll: boolean = false;

  get displayedItems() {
    return this.showAll ? this.contact?.purchasedData?.profile_data?.profile_expertises : this.contact?.purchasedData?.profile_data?.profile_expertises.slice(0, 3);
  }

  toggleShowAll() {
    this.showAll = !this.showAll;
  }

  ngOnInit(): void {

  }

}
